import React, { useEffect, useState } from 'react';
import client from '../api/client';

const ACTION_LABELS = {
  create: 'إضافة', update: 'تعديل', delete: 'حذف',
  'status:approved': 'اعتماد', 'status:rejected': 'رفض', 'status:under_review': 'تحويل لمراجعة',
  'bulk-status:approved': 'اعتماد جماعي', 'bulk-status:rejected': 'رفض جماعي',
};
const ACTION_ICONS = {
  create: '➕', update: '✏️', delete: '🗑️',
  'status:approved': '✅', 'status:rejected': '⛔', 'status:under_review': '🔍',
  'bulk-status:approved': '✅', 'bulk-status:rejected': '⛔',
};

function timeAgo(dateStr) {
  const diffMs = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return 'الآن';
  if (mins < 60) return `منذ ${mins} دقيقة`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `منذ ${hours} ساعة`;
  const days = Math.floor(hours / 24);
  return `منذ ${days} يوم`;
}

export default function ActivityLog() {
  const [rows, setRows] = useState([]);

  useEffect(() => { client.get('/audit', { params: { limit: 80 } }).then(r => setRows(r.data)); }, []);

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>سجل الأنشطة</h2>
      <div className="card">
        {rows.map(r => (
          <div key={r.id} style={{ display: 'flex', gap: 12, padding: '12px 0', borderBottom: '1px solid var(--line)' }}>
            <div style={{ fontSize: 18 }}>{ACTION_ICONS[r.action] || '•'}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13.5 }}>
                <b>{r.user_name || 'النظام'}</b>
                {' '}قام بـ <b>{ACTION_LABELS[r.action] || r.action}</b>
                {r.entity && <> على <b>{r.entity}</b></>}
                {r.entity_id && <span className="mono" style={{ color: 'var(--muted)' }}> #{r.entity_id}</span>}
              </div>
              {r.details && <div style={{ fontSize: 12.5, color: 'var(--muted)', marginTop: 2 }}>{r.details}</div>}
            </div>
            <div style={{ fontSize: 11.5, color: 'var(--muted)', whiteSpace: 'nowrap' }}>{timeAgo(r.created_at)}</div>
          </div>
        ))}
        {rows.length === 0 && <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 20 }}>لا توجد أنشطة مسجلة بعد</div>}
      </div>
    </div>
  );
}
